import { Arrays, idComparer } from "@gemma/utils";

import { Events } from "@timesheets/webapp-support";
import { IUser } from "./IUser";
import { Id } from "@gemma/typescript-types";
import { MutationTree } from "vuex";
import { Roles } from "@timesheets/constants-common";
import { WebApplicationConstants } from "@/setup/WebApplicationConstants";
import { WireEntities } from "@timesheets/common";

export const mutations: MutationTree<IUser> = {
  mutateCurrentRole(state, { role = undefined, forceSet = false }: { role?: string | WireEntities.Roles.IRecruitmentAgencyRole; forceSet: boolean } = { role: undefined, forceSet: false }) {
    const roleId: string | undefined = typeof role === "string" ? role : role && role.id;
    let newCurrentRole: WireEntities.Roles.IRecruitmentAgencyRole | undefined = undefined;

    if (roleId) {
      // Check that requested role is in the user's enabled roles
      const enabledRoles = state.roles.filter(role => role.isEnabled);
      newCurrentRole = enabledRoles.find(role => role.id === roleId);
      if (!newCurrentRole) {
        // If the role can't be found, then select the first enabled role
        if (enabledRoles.length > 0) {
          newCurrentRole = enabledRoles[0];
        }
      }
    }

    const oldCurrentRole = state.currentRole;
    const roleChanged = newCurrentRole ? (oldCurrentRole ? newCurrentRole.id !== oldCurrentRole.id : true) : newCurrentRole !== oldCurrentRole;
    if (roleChanged || forceSet) {
      const oldCurrentRole = state.currentRole;
      state.currentRole = newCurrentRole;

      if (roleChanged) {
        const currentRoleChangedEvent = new Events.CurrentRoleChangedEvent({ oldCurrentRole, newCurrentRole });
        WebApplicationConstants.listenerEventBuses.system.emit(currentRoleChangedEvent);
      }
    }
  },
  mutateRoleEnabled(state: IUser, { role, isEnabled }: { role: WireEntities.Roles.IRecruitmentAgencyRole; isEnabled: boolean }) {
    // if (!existingRole && role.contact && role.contact.account.id === state.currentSession.account.id) {
    //   Arrays.add(state.roles, role, idComparer);
    //   existingRole = role;
    // }

    role.isEnabled = isEnabled;
    const enabledRoles = state.roles.filter(role => role.isEnabled);
    const disabledRoles = state.roles.filter(role => !role.isEnabled);
    Arrays.add(isEnabled ? enabledRoles : disabledRoles, role, idComparer);
    Arrays.remove(isEnabled ? disabledRoles : enabledRoles, role, idComparer);
  },
  mutateRoleHasContractors(_state: IUser, { role, hasContractors }: { role: WireEntities.Roles.IRecruitmentAgencyRole; hasContractors: boolean }) {
    role.hasContractors = hasContractors;
  },
  mutateSuperAdministrator(state: IUser, { recruitmentAgencyAdministrationRole, isSuperAdministrator }: { recruitmentAgencyAdministrationRole: WireEntities.Roles.IRecruitmentAgencyAdministrationRole; isSuperAdministrator: boolean }) {
    const existingRole = state.roles.find(role => role.id === recruitmentAgencyAdministrationRole.id);

    if (existingRole && existingRole.type === Roles.RecruitmentAgencyAdministrationRole.TypeName) {
      const recruitmentAgencyAdministrationRole = existingRole as WireEntities.Roles.IRecruitmentAgencyAdministrationRole;
      if (recruitmentAgencyAdministrationRole.administrator) {
        recruitmentAgencyAdministrationRole.administrator.isSuperAdministrator = isSuperAdministrator;
      }
    }
  },
  mutateIsBetaAccessOn(state: IUser, { recruitmentAgencyAdministrationRole, isBetaAccessOn }: { recruitmentAgencyAdministrationRole: WireEntities.Roles.IRecruitmentAgencyAdministrationRole; isBetaAccessOn: boolean }) {
    const existingRole = state.roles.find(role => role.id === recruitmentAgencyAdministrationRole.id);

    if (existingRole && existingRole.type === Roles.RecruitmentAgencyAdministrationRole.TypeName) {
      const recruitmentAgencyAdministrationRole = existingRole as WireEntities.Roles.IRecruitmentAgencyAdministrationRole;
      recruitmentAgencyAdministrationRole.settings.isBetaAccessOn = isBetaAccessOn;
    }
  },
  clearRoles(state: IUser) {
    state.roles = [];
  },
  mutateHourFormat(state: IUser, { hourFormat, recruitmentAgency }: { hourFormat: WireEntities.RecruitmentAgency.IHourFormat; recruitmentAgency: WireEntities.Roles.IRecruitmentAgencyRole<unknown> | Id<string> }) {
    const recruitmentAgencyId = typeof recruitmentAgency === "string" ? recruitmentAgency : recruitmentAgency.id;
    const roles = state.roles.filter(role => role.recruitmentAgency.id === recruitmentAgencyId);
    for (const role of roles) {
      role.recruitmentAgency.settings.hourFormat = { decimal: hourFormat.decimal };
    }
  },
  setRoles(state: IUser, roles: WireEntities.Roles.IRecruitmentAgencyRole[]) {
    state.roles = roles;
  },
};
